import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import { useLanguage } from "../../context/LanguageContext";
import { Card, CardContent } from "../../components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";
import { Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminCustomers = () => {
  const { getAuthHeaders } = useAuth();
  const { t, isRTL } = useLanguage();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(`${API}/users`, { headers: getAuthHeaders() });
        setUsers(res.data.filter((u) => u.role === "customer"));
      } catch (error) {
        console.error(t("failedToFetchCustomers"));
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, [getAuthHeaders, t]);

  return (
    <div className="space-y-6" data-testid="admin-customers">
      <h2 className="text-xl font-heading font-semibold text-white">{t("customers")} ({users.length})</h2>
      
      <Card className="bg-slate-800/50 border-slate-700">
        <CardContent className="p-0">
          {loading ? (
            <div className="p-8 text-center text-slate-400">{t("loading")}</div>
          ) : users.length === 0 ? (
            <div className="p-8 text-center">
              <Users className="w-12 h-12 mx-auto text-slate-500 mb-4" />
              <p className="text-slate-400">{t("noCustomersYet")}</p>
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow className="border-slate-700">
                  <TableHead className="text-slate-300">{t("name")}</TableHead>
                  <TableHead className="text-slate-300">{t("username")}</TableHead>
                  <TableHead className="text-slate-300">{t("email")}</TableHead>
                  <TableHead className="text-slate-300">{t("phone")}</TableHead>
                  <TableHead className="text-slate-300">{t("status")}</TableHead>
                  <TableHead className="text-slate-300">{t("joined")}</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {users.map((user) => (
                  <TableRow key={user.id} className="border-slate-700">
                    <TableCell className="text-white font-medium">{user.full_name || "-"}</TableCell>
                    <TableCell className="text-slate-300">{user.username}</TableCell>
                    <TableCell className="text-slate-300">{user.email || "-"}</TableCell>
                    <TableCell className="text-slate-300">{user.phone || "-"}</TableCell>
                    <TableCell>
                      <Badge className={user.is_active ? "bg-green-500/20 text-green-400" : "bg-red-500/20 text-red-400"}>
                        {user.is_active ? t("active") : t("inactive")}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-slate-400">
                      {user.created_at ? new Date(user.created_at).toLocaleDateString(isRTL ? 'ar-LY' : 'en-US') : "-"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminCustomers;
